import { Center, Text, VStack } from '@chakra-ui/react'

interface LinkErrorStateProps {
    title: string
    description: string
}

const LinkErrorState = ({ title, description }: LinkErrorStateProps) => {
    return (
        <Center bg='bg.subtle' flexDirection='column' minH='100dvh' px='4' w='full'>
            <VStack gap='2' maxW='315px' textAlign='center' w='full'>
                <Text color='text.fg' fontSize='28px' fontWeight='600' lineHeight='36px'>
                    {title}
                </Text>
                <Text color='text.fg_muted' fontSize='16px' lineHeight='24px'>
                    {description}
                </Text>
            </VStack>
        </Center>
    )
}

export const InvalidLinkState = () => {
    return (
        <LinkErrorState description='Откройте запись по ссылке филиала' title='Ссылка неверная' />
    )
}

export const BranchNotFoundState = () => {
    return (
        <LinkErrorState description='Филиал закрыт или ссылка устарела' title='Филиал не найден' />
    )
}
